/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Bom_Duplicate_MaterialInputs */

const vi_packaging_bom_duplicate_material = /** @type {(inputs: Packaging_Bom_Duplicate_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vật tư đã có trong danh sách`)
};

/**

* @param {Packaging_Bom_Duplicate_MaterialInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_bom_duplicate_material = /** @type {((inputs?: Packaging_Bom_Duplicate_MaterialInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Bom_Duplicate_MaterialInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_bom_duplicate_material(inputs)
});